import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ro from './locales/ro.json';

i18n.use(initReactI18next).init({
  lng: import.meta.env.VITE_APP_LOCALE ?? 'ro',
  fallbackLng: 'ro',
  resources: {
    en: { translation: en },
    ro: { translation: ro },
  },
  interpolation: {
    escapeValue: false,
  },
  initImmediate: false,
});

export default i18n;
